<template>
    <div> 
        
        <MenuTopTemplate :titulo="'MEUS PEDIDOS'" :icone="require('../assets/icons/ic_meus_pedidos.png')" :onPressedClose="navegarCardapio"/>
        
        
        <div class="corpo anim-entrada">   
            
            <!-- digitar telefone -->
            <!-- <div class="status" v-if="todosPedidos == null"> --> 
                <div class="status" >
                    <div>
                        <TelefoneComDDD :mostrar="true" @callback="telefoneCallback" :whiteBackground="true" :loadingEnviarTelefone="loadingEnviarTelefone" :numeroTel="telefone"/>
                    </div>
                    
                </div>
                
                
                <!-- <div class="card"  v-if="cada.status.toLowerCase() == 'concluido' || cada.status.toLowerCase() == 'cancelado' "></div> -->
                <!-- status depois de digitado o telefone -->
                <div  v-if="todosPedidos != null">
                    
                    <h2 class="titulo-medio">Meus Pedidos</h2>
                
                <!-- <h3>PEDIDOS CORRENTES</h3>   -->
                 <div style="display: flex;padding-inline:var(--padding-padrao);gap: var(--padding-padrao);">
                     <button @click="showPedidosAnteriores=false" :class="showPedidosAnteriores?'btn-normal btn-nao-selecionado':'btn-normal btn-selecionado'" type="">Correntes</button>
                     <button @click="showPedidosAnteriores=true" :class="!showPedidosAnteriores?'btn-normal btn-nao-selecionado':'btn-normal btn-selecionado'" type="">Anteriores</button>
                </div>
                <div v-if="verificaSeTemPedido('correntes')&&!showPedidosAnteriores" class="nenhum-pedido">
                    <p>Nenhum pedido corrente encontrado.</p> 
                </div>
                <div v-if="verificaSeTemPedido('anteriores')&&showPedidosAnteriores" class="nenhum-pedido">
                    <p>Nenhum pedido anterior encontrado.</p>
                </div>
                <div class="card-corrente" v-if="!showPedidosAnteriores">
                    <div v-for="(cada, index) in todosPedidos" :key="index">
                        <div class="card-pedidos-recorrentes"  v-if="cada.status.toLowerCase() !== 'concluido' && cada.status.toLowerCase() !== 'cancelado'  && cada.status.toLowerCase() != 'pagamento não efetuado' ">
    <!-- data e status  -->
                            <div class="cada-pedido cada-pedido-borda">
                                <div class="flex-key-value">
                                    <!-- <p class="data-pedido">{{ cada.pedido.dataBrasil() }}</p> -->
                                    <p class="data-pedido">{{ cada.dataBrasil() }}</p>
                                    <!-- <p class="data-pedido">{{ cada.dataPedido}}</p> -->
                                    <!-- <p class="status-pedido">{{ cada.status }}</p> -->
                                </div>
                                <!-- <p>{{ JSON.stringify(cada) }}</p> -->
                                <ShowStatusPedido :status="cada.status" :retirar="cada.pedido.endereco==='retirar'?true:false"/>
    <!-- itens  -->
                                <div class="items-container">
                                    <div v-for="(item, index2) in cada.pedido.itens" :key="index2">
                                        <p>{{ item.qtdConcatenada }}x - {{ item.nome }}</p>
                                        <div v-if="item.subitens">
                                            <div class="subitem" v-for="sub in agruparSubitens(item.subitens)" :key="sub.nome">
                                                <!-- <p>{{ subitem }}</p> -->
                                                <p>{{ sub.quantidade }}x {{ sub.nome }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
    <!-- valores                              -->
                                <div class="flex-key-value">
                                    <p>Valor do pedido</p>
                                    <p class="valores">{{ !cada.pedido.valorTotalCarrinho ? "" : converterParaVirgula(cada.pedido.valorTotalCarrinho) }}</p>
                                    
                                </div>
                                <div v-if="cada.pedido.taxaEntrega">
                                    <div class="flex-key-value">
                                        <p>Taxa de entrega</p>
                                        <p class="valores">{{ converterParaVirgula(cada.pedido.taxaEntrega) }}</p>
                                    </div>
                                    <hr>
                                    <div class="flex-key-value">
                                        <p>Total</p>
                                        <p class="valores">{{ converterParaVirgula(cada.pedido.taxaEntrega+cada.pedido.valorTotalCarrinho) }}</p>
                                    </div>
                                </div>
    <!-- pix qrcode  -->
                                <div >
                                    <div v-if=" cada.pedido.qrcode != null && cada.status.toLowerCase() == 'pagamento pendente'">
                                        <mp-status-screen-pix :pix_data="cada.pedido.qrcode" :data_hora_qrcode="cada.pedido.pixData"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>

                <div v-if="this.showPedidosAnteriores" class="card-anteriores">

                    <div v-for="(cada, index) in todosPedidos" :key="index">
                        <div  v-if="cada.status.toLowerCase() == 'concluido' || cada.status.toLowerCase() == 'cancelado' || cada.status.toLowerCase() == 'pagamento não efetuado' " class="card-pedidos-recorrentes">

                            <!-- data e status  -->
                            <div class="cada-pedido cada-pedido-anterior">

                                <div class="flex-key-value">
                                    <p class="data-pedido">{{ cada.dataBrasil() }}</p>
                                    <!-- <p class="status-pedido">{{ cada.status }}</p> -->
                                </div>
                                
                                <ShowStatusPedido :status="cada.status" :retirar="cada.pedido.endereco==='retirar'?true:false"/>

                                <!-- itens  -->
                                 <div class="items-container">
                                    <div v-for="(item, index2) in cada.pedido.itens" :key="index2">
                                        <p>{{ item.qtdConcatenada }}x - {{ item.nome }}</p>
                                        <div v-if="item.subitens">
                                            <div class="subitem" v-for="sub in agruparSubitens(item.subitens)" :key="sub.nome">
                                                <p>{{ sub.quantidade }}x {{ sub.nome }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- valores                              -->
                                <div class="flex-key-value">
                                    <p>Valor do pedido</p>
                                    <p>{{ !cada.pedido.valorTotalCarrinho ? "" : converterParaVirgula(cada.pedido.valorTotalCarrinho+cada.pedido.taxaEntrega) }}</p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <!-- <p style="background: white;">{{JSON.stringify(todosPedidos)}}</p> -->
            </div>

        </div>
        

  
        
        <div class="div-botao-voltar">
            <!-- <menu-bottom-template  /> -->
            <button class="botao-voltar" @click="navegarCardapio()">Voltar</button>
        </div>

    </div>  

</template>

<script>
import MenuTopTemplate from "../components/Base/MenuTopTemplate.vue"
// import MenuBottomTemplate from '@/components/Base/MenuBottomTemplate.vue'
import TelefoneComDDD from '@/components/Delivery/TelefoneComDDD.vue'
import Swal from 'sweetalert2'
import ApiDelivery from '@/api/ApisDelivery'
import { converterParaDinheiroString } from '@/utils/Dinheiro'
import { setarCores } from '@/utils/SetarCores'
import MpStatusScreenPix from '@/components/mercadopago/MpStatusScreenPix.vue'
import ShowStatusPedido from "@/components/Delivery/ShowStatusPedido.vue"
 
export default {         
    name: "StatusDeliveryView",

    components: { MenuTopTemplate,  TelefoneComDDD, MpStatusScreenPix , ShowStatusPedido }, 

    data() {  
        return {
            loading: false,
            intervalId: null,
            devoRefreshar: true,
            loadingEnviarTelefone: false,
            digitouDados: false,
            dadosConta: {},
            ddd: "",
            telefone: "",

            // daqui pra baixo eh o retorno da api
            todosPedidos: null,
            showPedidosAnteriores:false,
        }
    },

    created() {
        setarCores(this.$store.state.cor1, this.$store.state.cor2,this.$store.state.corTexto)
    },


    mounted() {
        this.iniciarRefresh();
    },

    beforeDestroy() {
        this.pararRefresh();
    },
    methods: {
        /**
         * Busca o histórico de pedidos a cada 10 segundos.
         */
        iniciarRefresh() {
            if (this.intervalId) return;

            this.intervalId = setInterval(() => {
                if(this.telefone.length>7){
                    if (this.devoRefreshar) {
                        console.log("Refreshando"+this.telefone);
                        this.buscarPedidosSemLoading();
                    } else {
                        this.pararRefresh();
                    }
                }else {console.log("Telefone tem menos de 7 dig:"+this.telefone);}
            }, 10000);
        },
        pararRefresh() {
            clearInterval(this.intervalId);
            this.intervalId = null;
            console.log("Parou de Refreshar");
        },
        /**
         * Verifica se houve alteração no status dos pedidos com pagamento via PIX pendente e atualiza a session com os novos pedidos pendentes.
         */
        checkAndSavePixPendente(){
            this.comparaPixPendente();
            this.salvarPixPendente();
        },
        /**
         * Compara o vetor de Pix pendente SALVO com o ATUAL para ver se mudou o status
         */
        comparaPixPendente(){
            const savedPixPendente = JSON.parse(sessionStorage.getItem("pix-pendente"));
            if (savedPixPendente && savedPixPendente.length>0){
                // console.log("item salvos:")
                // console.log(savedPixPendente);
                savedPixPendente.forEach(id =>{
                    const posicao = this.todosPedidos.findIndex(p=>p.idPedido === id)
                    // console.log("Position:"+posicao)
                    if (posicao !== -1 ){//não achou o id no segundo vetor
                        switch (this.todosPedidos[posicao].status){
                            case "PAGAMENTO PENDENTE": console.log("Pix Continua Pendente"+id);break;
                            case "PRODUZINDO": this.$router.push({path: "/deliverysucessopix",});break;
                            case "PAGAMENTO NÃO EFETUADO" : console.log("O Qr expirou"+id);break;
                            default : console.log("STATUS DESCONHECIDO, ERRO!");break;
                        }
                    }
                })
            }
        },

        /**
         * Salva na session os ids dos pedidos que esta com o pagamento PIX pendente
         */
        salvarPixPendente(){
            // console.log("STATUS")
            const vetIdPedido=[];
            this.todosPedidos.forEach( e => {
                if (e.status==='PAGAMENTO PENDENTE'){
                    vetIdPedido.push(e.idPedido)
                }
            });
            // console.log(vetIdPedido)
            sessionStorage.setItem('pix-pendente',JSON.stringify( vetIdPedido));
        },
        
        telefoneCallback(tel) {
            this.telefone = tel.telefone;
            console.log(tel.telefone);
            this.enviarTelefone()
        },

        converterParaVirgula(dindin) {
            return converterParaDinheiroString(dindin)
        },

        enviarTelefone() {
            this.loadingEnviarTelefone = true
            ApiDelivery.buscarPedidos(this.$store.state.cnpj, this.telefone)
                .then( res => {
                    // console.log('Aqui')
                    console.log(JSON.parse(JSON.stringify(res)));
                    this.todosPedidos =  this.organizarPedidosEmQtd(res)
                    this.loadingEnviarTelefone = false
                    this.checkAndSavePixPendente();
                }).catch( err => {
                    console.log(err)
                    this.loadingEnviarTelefone = false   
                    
                    Swal.fire({
                        title: "Nenhum pedido encontrado!",
                        html: "Parece que você ainda não fez nenhum pedido! <br><br> Após seu primeiro pedido, ele e os demais pedidos aparecerão aqui."
                    })
                })
        },

 

        buscarPedidosSemLoading() {
            // this.refreshando = true
            ApiDelivery.buscarPedidos(this.$store.state.cnpj, this.telefone)
            .then( res => {
                this.todosPedidos = this.organizarPedidosEmQtd(res)
                this.checkAndSavePixPendente();
            }).catch( err => {
                console.log(err)
            }).finally(() => {
                // this.refreshando = false
            })
        },
        //Agrupamos os itens e somamos a quantidade
        organizarPedidosEmQtd(pedidos) {
            for (const i of pedidos) {
                const listanova = []
                for (const j of i.pedido.itens) {
                    const index = listanova.findIndex(test => test.nome == j.nome && JSON.stringify(test.subitens) === JSON.stringify(j.subitens))
                    if (index == -1) {
                        j.qtdConcatenada = j.quantidade
                        listanova.push(j)
                    } else {
                        listanova[index].qtdConcatenada = listanova[index].qtdConcatenada + j.quantidade
                    }

                }
                i.pedido.itens = listanova
            }
            return pedidos
        },
        navegarCardapio(){
            this.$router.push({path: '/cardapio'})
        },
        agruparSubitens(subitens) {
            if (!Array.isArray(subitens)) return [];

            const mapa = {};

            subitens.forEach(nome => {
                mapa[nome] = (mapa[nome] || 0) + 1;
            });

            return Object.entries(mapa).map(([nome, quantidade]) => ({
                nome,
                quantidade
            }));
        },
        verificaSeTemPedido(tipo){
            let temCardsDesseTipo= true;
            if(tipo==='correntes'){
                this.todosPedidos.forEach(e=>{
                    if(e.status==='PRODUZINDO'||e.status==='ENTREGA'||e.status==='PRONTO RETIRADA'||e.status==='PAGAMENTO PENDENTE'||e.status==='AGUARDANDO'){
                        temCardsDesseTipo=false;
                    }
                })
            }
            if(tipo==='anteriores'){
                this.todosPedidos.forEach(e=>{
                    if(e.status==='CONCLUIDO'||e.status==='CANCELADO'||e.status==='PAGAMENTO NÃO EFETUADO'){
                        temCardsDesseTipo=false;
                    }
                })
            }
            return temCardsDesseTipo;
        }
    }
}
</script>

<style scoped>
.titulo-medio{
    margin: 0px;
    padding-bottom: var(--padding-padrao);
}
.cada-pedido {
}
.corpo{
}

.nenhum-pedido {
    color: white;
    padding-top: var(--padding-padrao);
}

.items-container {
    padding: var(--padding-padrao);
}
.items-container>div>p{
    text-align: start;
    color: black;
    padding-block: 3px;
}
.items-container > span {font-size: 0.7rem; border-bottom: 1px solid black;}

.cada-pedido-anterior hr {
    margin: 0; 
    border: solid 2px black;
}

.card-corrente,.card-anteriores {
    min-height: 10px;
    z-index: 10;
}
.data-pedido {font-size: 0.7rem; text-align: start;}
.status-pedido {font-size: 0.9rem; text-align: end; font-weight: bold;}

.flex-key-value {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-block: 2px;
}

.valores {
    color: green;
    font-size: 1rem;
    font-weight: bold;
}
.card-pedidos-recorrentes{
    border: 1px solid var(--cinza-escuro);
    background: white;
    margin: var(--padding-padrao);
    padding: var(--padding-padrao);
    border-radius: var(--border-radius-padrao);
}
.div-items{
    background: black;
}
.icon-seta{
    transition: transform 0.4s ease-in-out;
}
.icon-seta.rotated{
    transform: rotate(180deg);
}

.div-botao-voltar{
    padding-inline: var(--padding-padrao);
    padding-bottom: var(--padding-padrao);
    border-radius: var(--border-radius-padrao);
}
.botao-voltar{
    width: 100%;
    height: 50px;
    color: var(--cor-texto);
}
.btn-selecionado{
    background: var(--cor2);
    color: white;
    font-weight: bold;
}
.btn-nao-selecionado{
    color: var(--cor-texto);
    font-weight: bold;
}
.subitem{
    text-align: start;
    padding-left: var(--padding-padrao);
    font-size: 0.8em;
}
</style>

